import { MY_FORMATS, TranslateHttpLoaderFactory } from './app/app.module';
import { CsvService } from '@shared/services/csv.service';
import { appInitializerProviders, BASE_URL, httpInterceptorProviders } from '@core';
import { environment } from '@env/environment';
import { LoginService } from '@core/authentication/login.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CoreModule } from '@core/core.module';
import { ThemeModule } from '@theme/theme.module';
import { RoutesModule } from './app/routes/routes.module';
import { SharedModule } from '@shared/shared.module';
import { FormlyConfigModule } from './app/formly-config.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ToastrModule } from 'ngx-toastr';
import { QuillModule } from 'ngx-quill';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';

//TODO: Test i18n-Versioning
const version = new Date().getTime(); // z. B. 1728401080000
const locale = 'de-DE';
fetch(`/assets/i18n/${locale}.json?v=${version}`);
const localeUS = 'en-US';
fetch(`/assets/i18n/${localeUS}.json?v=${version}`);

bootstrapApplication(AppComponent, {
  providers: [
    // Since Angular 21 an app without this provider runs zoneless. The components here set
    // plain fields in subscribe callbacks and rely on zone.js to render them.
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom(
      BrowserModule,
      MatDatepickerModule,
      CoreModule,
      ThemeModule,
      RoutesModule,
      SharedModule,
      FormlyConfigModule.forRoot(),
      NgxPermissionsModule.forRoot(),
      ToastrModule.forRoot(),
      QuillModule.forRoot({
        suppressGlobalRegisterWarning: true,
      }),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: TranslateHttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    CsvService,
    { provide: BASE_URL, useValue: environment.baseUrl },
    { provide: LoginService, useClass: LoginService },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    httpInterceptorProviders,
    appInitializerProviders,
    { provide: LOCALE_ID, useValue: 'de-DE' }, //Add the id and the language code here
    { provide: 'API_URL', useValue: environment.apiUrl },
    { provide: 'BASE_URL', useValue: environment.baseUrl },
    { provide: 'API_URL_PUBLIC', useValue: environment.apiUrlPublic },
    { provide: 'SERVER_URL', useValue: environment.serverUrl },
    { provide: 'VERSION', useValue: environment.version },
    { provide: 'PROD', useValue: environment.production },
    { provide: 'TEST_TOOLS', useValue: environment.testTools },
    { provide: 'VERSION_DATE', useValue: environment.versionDate },
    { provide: 'APP_TITLE', useValue: environment.appTitle },
    { provide: 'SPONSOR_FIRST_YEAR', useValue: environment.sponsorFirstYear },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
  ],
}).catch(err => console.error(err));
